'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Audits(eyebrow, title, lead, points, action, coverageTitle, coverageHint, areas, deliverablesLead, deliverables, depth) {
  this.gw = null;
  this.gz = null;
  this.gx = null;
  this.gy = null;
  this.gp = null;
  this.gs = null;
  this.gr = null;
  this.gq = null;
  this.gu = null;
  this.gt = null;
  this.gv = null;
  this.gw = eyebrow;
  this.gz = title;
  this.gx = lead;
  this.gy = points;
  this.gp = action;
  this.gs = coverageTitle;
  this.gr = coverageHint;
  this.gq = areas;
  this.gu = deliverablesLead;
  this.gt = deliverables;
  this.gv = depth;
}
export { $c_Lio_intela_sites_intelacloud_content_Audits as $c_Lio_intela_sites_intelacloud_content_Audits };
$p = $c_Lio_intela_sites_intelacloud_content_Audits.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Audits;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Audits() {
}
export { $h_Lio_intela_sites_intelacloud_content_Audits as $h_Lio_intela_sites_intelacloud_content_Audits };
$h_Lio_intela_sites_intelacloud_content_Audits.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-577069090), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Audits)) {
    if ((this.gw === x$0.gw)) {
      var x = this.gz;
      var x$2 = x$0.gz;
      var $x_4 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_4 = false;
    }
    if (($x_4 && (this.gx === x$0.gx))) {
      var x$3 = this.gy;
      var x$4 = x$0.gy;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.gp;
      var x$6 = x$0.gp;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_2 = false;
    }
    if ((($x_2 && (this.gs === x$0.gs)) && (this.gr === x$0.gr))) {
      var x$7 = this.gq;
      var x$8 = x$0.gq;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_1 = false;
    }
    if ((($x_1 && (this.gu === x$0.gu)) && (this.gt === x$0.gt))) {
      return (this.gv === x$0.gv);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 11;
});
$p.I = (function() {
  return "Audits";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.gw;
      break;
    }
    case 1: {
      return this.gz;
      break;
    }
    case 2: {
      return this.gx;
      break;
    }
    case 3: {
      return this.gy;
      break;
    }
    case 4: {
      return this.gp;
      break;
    }
    case 5: {
      return this.gs;
      break;
    }
    case 6: {
      return this.gr;
      break;
    }
    case 7: {
      return this.gq;
      break;
    }
    case 8: {
      return this.gu;
      break;
    }
    case 9: {
      return this.gt;
      break;
    }
    case 10: {
      return this.gv;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Audits(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bn)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Audits as $isArrayOf_Lio_intela_sites_intelacloud_content_Audits };
var $d_Lio_intela_sites_intelacloud_content_Audits = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Audits, "io.intela.sites.intelacloud.content.Audits", ({
  bn: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Audits as $d_Lio_intela_sites_intelacloud_content_Audits };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Audits.js.map
